import { z } from 'zod';

export const DEFAULT_PROVIDER_COMPANY = '10000000-0000-4000-8000-000000000001';
export const corteStatuses = ['borrador', 'revisado', 'pagado', 'en_disputa'] as const;
const date = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
export const nullableAmount = z.preprocess(v => v === '' || v == null ? null : v, z.coerce.number().finite().nullable());
export const corteInput = z.object({
  id: z.string().uuid().optional(), provider_id: z.string().uuid(),
  period_start: date, period_end: date, cut_date: date,
  supplier_reported_total: nullableAmount, previous_balance: z.coerce.number().finite(),
  advances: z.coerce.number().finite().min(0), source_file_path: z.string().max(1000).nullable().optional(),
  status: z.enum(corteStatuses), notes: z.string().max(4000).nullable().optional(),
}).refine(v => v.period_end >= v.period_start, 'El periodo final debe ser posterior al inicial');
export const settlementBookingPatch = z.object({
  id: z.string().uuid(), corte_id: z.string().uuid(),
  patch: z.object({
    service_date: date.nullable().optional(), tour_title: z.string().max(400).nullable().optional(),
    price_option: z.string().max(400).nullable().optional(), hotel: z.string().max(400).nullable().optional(),
    customer_first_name: z.string().max(400).nullable().optional(), customer_last_name: z.string().max(400).nullable().optional(),
    pax_adt: z.coerce.number().int().min(0).optional(), pax_chd: z.coerce.number().int().min(0).optional(),
    price_adult: z.coerce.number().finite().optional(), price_child: z.coerce.number().finite().optional(),
    balance_usd: z.coerce.number().finite().optional(), balance_mxn: z.coerce.number().finite().optional(), balance_eur: z.coerce.number().finite().optional(),
    supplier_reported_cost: nullableAmount.optional(), supplier_reported_difference: nullableAmount.optional(),
    expected_cost: nullableAmount.optional(), pay_on_board_amount: nullableAmount.optional(),
    pay_on_board_currency: z.enum(['MXN','USD','EUR']).nullable().optional(),
    boarding: z.string().max(400).nullable().optional(), notes: z.string().max(4000).nullable().optional(),
    discrepancy_note: z.string().max(4000).nullable().optional(), settlement_origin: z.string().max(200).nullable().optional(),
    calendar_verified: z.boolean().nullable().optional(), no_show: z.boolean().nullable().optional(),
  }).strict(),
});
export const priceListInput = z.object({
  id: z.string().uuid().optional(), provider_id: z.string().uuid(), tour_name: z.string().trim().min(1).max(400),
  option_name: z.string().trim().min(1).max(400), origin: z.string().trim().min(1).max(200),
  adult_price: nullableAmount, child_price: nullableAmount, tax_amount: nullableAmount,
  currency: z.enum(['MXN','USD','EUR']), valid_from: date, notes: z.string().max(4000).nullable().optional(),
});
export function providerLabel(p: { code?: string | null; name?: string | null; display_alias?: string | null }, onlyCode: boolean) {
  return onlyCode ? p.code || 'Sin código' : p.display_alias || p.name || p.code || 'Proveedor';
}
export function calculatedDifference(cost: number | null, board: number | null, rate: number | null, transferred: number | null) {
  if (cost == null || board == null || rate == null || transferred == null) return null;
  return Math.round((cost - board * rate - transferred) * 100) / 100;
}
export function corteBalance(subtotal: number | null, previous: number, advances: number, paid: number | null) {
  if (subtotal == null || paid == null) return null;
  return Math.round((subtotal + previous - advances - paid) * 100) / 100;
}
export function amountsMatch(a: number | null, b: number | null) {
  return a == null || b == null ? null : Math.round(a * 100) === Math.round(b * 100);
}
export function operationsCortePath(path: string) {
  return /^\/admin\/provider-cortes(?:\/[0-9a-f-]{36})?\/?$/i.test(path);
}